import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { PATHS } from "constants/pathConstants";
import SurveyWrapper from "components/v3/sharedComponents/surveys/SurveyWrapper";
import { selectKitsSelectedToBeOrdered } from "store/reducers/order/OrderInformationSlice";
import { Model } from "survey-core";

type InformedConsentSurveyProps = {
  onSurveyInstantiated?: (surveyModel: Model) => void;
  onCurrentPageChanging?: (
    surveyModel: Model,
    options: Record<string, any>
  ) => void;
};

const SURVEY_ID = "informed-consent-survey";

const InformedConsentSurvey = ({
  onSurveyInstantiated,
  onCurrentPageChanging
}: InformedConsentSurveyProps): React.ReactElement => {
  const history = useHistory();
  const kitsSelectedToBeOrdered = useSelector(selectKitsSelectedToBeOrdered);

  const handleOnComplete = (): void => {
    history.push(PATHS.ORDER_KIT);
  };

  const handleOnSurveyInstantiated = (surveyModel: Model): void => {
    kitsSelectedToBeOrdered.forEach((kit_uuid: string) => {
      surveyModel.getQuestionByName(kit_uuid).value = true;
    });
    surveyModel.completeText = "Save & Continue";
    onSurveyInstantiated?.(surveyModel);
  };

  return (
    <SurveyWrapper
      focusFirstQuestionAutomatic={false}
      surveyId={SURVEY_ID}
      onComplete={handleOnComplete}
      onCurrentPageChanging={onCurrentPageChanging}
      onSurveyInstantiated={handleOnSurveyInstantiated}
      overrideNextButtonEnabled={true}
      //surveyJsonOverride={surveyJsonOverride}
      useStoredSurveyData={false}
    />
  );
};

export default InformedConsentSurvey;
